define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/Boolean"
], function(array, declare, BooleanRen) {

	return declare(BooleanRen, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: switch to Style since it holds InactiveSizes
			var style = ctx.getRowNode();
			ctx.keyValue = array.indexOf(style.InactiveSizes || [], ctx.getNodeURL());
			ctx.pushParams().setNodeURL(style.$URL);
			ctx.setReadOnly(false);
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context
			ctx.keyValue = null;
			ctx.pop();
			this.inherited(arguments);
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: keyValue is indicator if size is in InactiveSizes or not
			return ctx.keyValue == -1;
		}
	});
});